import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <a href="#hero" className="footer__logo">
              <svg viewBox="0 0 40 40" className="footer__logo-icon">
                <defs>
                  <linearGradient id="footerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#00d4ff"/>
                    <stop offset="100%" stopColor="#7c3aed"/>
                  </linearGradient>
                </defs>
                <path d="M20 4L10 14l3 5-5 11h8l2.5-4L20 30l1.5-4L24 30h8l-5-11 3-5L20 4zm0 5l5 6-1.5 3.5h-7L15 15l5-6z" fill="url(#footerGrad)"/>
              </svg>
              <span className="footer__logo-text">
                <strong>Wolf</strong>Technologies
              </span>
            </a>
            <p className="footer__tagline">
              Building intelligent mobile experiences with AI and AWS cloud technology.
              Based in the United Kingdom.
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__links-group">
              <h4>Company</h4>
              <a href="#about">About Us</a>
              <a href="#services">Services</a>
              <Link to="/portfolio">Portfolio</Link>
              <a href="#process">Our Process</a>
              <a href="#contact">Contact</a>
            </div>
            <div className="footer__links-group">
              <h4>Services</h4>
              <a href="#services">iOS Development</a>
              <a href="#services">Android Development</a>
              <a href="#services">AI Integration</a>
              <a href="#services">AWS Cloud Solutions</a>
            </div>
            <div className="footer__links-group">
              <h4>Technology</h4>
              <a href="#technology">AWS Platform</a>
              <a href="#technology">AI & Machine Learning</a>
              <a href="#technology">Cloud Architecture</a>
              <a href="#technology">Security</a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {currentYear} WolfTechnologies Ltd. All rights reserved.</p>
          <p className="footer__location">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
              <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
            </svg>
            United Kingdom &middot; wolftechnologies.co.uk
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
